export default __webpack_public_path__ + "static/media/aboutus.8a0f35f6.jpg";